import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

function setGalleryDimensions(gallerySelector) {
  const gallery = document.querySelector(gallerySelector);
  if (!gallery) return;

  const links = gallery.querySelectorAll('a');
  links.forEach(link => {
    const img = link.querySelector('img');
    if (!img) return;

    function applyDims() {
      link.setAttribute('data-pswp-width', img.naturalWidth);
      link.setAttribute('data-pswp-height', img.naturalHeight);
    }

    if (img.complete) {
      applyDims();
    } else {
      img.addEventListener('load', applyDims);
    }
  });
}

setGalleryDimensions('#ps-gallery');

const options = {
    // may select multiple "galleries"
    gallery: '#ps-gallery',

    // Elements within gallery (slides)
    children: 'a',

    // setup PhotoSwipe Core dynamic import
    pswpModule: () => import('photoswipe')
}
const lightbox = new PhotoSwipeLightbox(options);
lightbox.on('uiRegister', function() {
  lightbox.pswp.ui.registerElement({
    name: 'custom-caption',
    order: 9,
    isButton: false,
    appendTo: 'root',
    html: 'Caption text',
    onInit: (el, pswp) => {
      lightbox.pswp.on('change', () => {
        const currSlideElement = lightbox.pswp.currSlide.data.element;
        let captionHTML = '';
        if (currSlideElement) {
          const hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
          if (hiddenCaption) {
            // get caption from element with class hidden-caption-content
            captionHTML = hiddenCaption.innerHTML;
          } else {
            // get caption from alt attribute
            captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
          }
        }
        if (captionHTML) {
            el.innerHTML = captionHTML || '';
        } else {
            el.classList.add('hidden')
        }
        
      });
    }
  });
});
lightbox.init();